import styled from 'styled-components';
import ExpressCareSvg from '../../../assets/onboarding/newHome/express-care.svg';

const ExpressCareIcon = styled(ExpressCareSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '4.4rem'};
height: ${props => props.height || '4.4rem'};
display: flex;
`;

export default ExpressCareIcon;
